<template>
  <v-layout column class="pr-2 pl-3" id="mask-toolbar">
    <v-flex xs12 class="mb-2 body-2">
      {{ $tc("Mask", 1) }} {{ selectedMask ? selectedMask.mk_label : "" }}
    </v-flex>

    <v-flex class="mb-3">
      <div class="toolbar-section-title">{{ $tc("DuctEntry", 2) }}</div>
      <v-btn small block :disabled="disabled" @click="openDuctSelector">
        <v-icon left>add</v-icon>
        <span>{{ $t("Create") }}...</span>
      </v-btn>
      <v-btn small block :disabled="disabled" @click="renameDuctEntries">
        <v-icon left>label</v-icon>
        <span>{{ $t("Relabel") }}</span>
      </v-btn>
    </v-flex>

    <v-flex>
      <div class="toolbar-section-title">{{ $tc("Mask", 1) }}</div>
      <v-btn small block :disabled="disabled" @click="openMirrorSection">
        <v-icon left>content_copy</v-icon>
        <span>{{ $t("MirrorTo") }}...</span>
      </v-btn>
      <v-btn small block :disabled="disabled" @click="openResizeSection">
        <v-icon left>photo_size_select_small</v-icon>
        <span>{{ $t("Resize") }}...</span>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import DevTag from "@/components/_Atoms/DevTag";

export default {
  name: "MaskToolbar",

  components: { DevTag },

  mixins: [checkPermissionsMixin],

  computed: {
    disabled() {
      return !this.isSuperAdmin;
    },

    selectedMask() {
      return this.$store.getters.getSelectedMask;
    }
  },

  methods: {
    ...mapActions(["setMasksTabSideSection", "setDuctEntryMode", "editMask"]),

    openDuctSelector() {
      this.setMasksTabSideSection("ductEntryTypeSelector");
      this.setDuctEntryMode("create");
    },

    renameDuctEntries() {
      let ductEntries = JSON.parse(
        JSON.stringify(this.selectedMask.duct_entries)
      );
      ductEntries.sort(this.compareDuctEntryPositions);
      let ductEntryLabel = 1;
      ductEntries.forEach(ductEntry => {
        ductEntry.mde_label = this.selectedMask.mk_label + ductEntryLabel;
        ductEntryLabel++;
      });
      let dataToUpdate = [{ field: "duct_entries", value: ductEntries }];
      this.editMask(dataToUpdate);
    },

    compareDuctEntryPositions(a, b) {
      let positionA = this.getRelativePosition(a);
      let positionB = this.getRelativePosition(b);
      if (positionA < positionB) {
        return -1;
      }
      if (positionA > positionB) {
        return 1;
      }
      return 0;
    },

    getRelativePosition(ductEntry) {
      return ductEntry.mde_left * 100 + ductEntry.mde_top;
    },

    openMirrorSection() {
      this.setMasksTabSideSection("maskMirror");
    },

    openResizeSection() {
      this.setMasksTabSideSection("maskResize");
    }
  }
};
</script>

<style scoped>
.toolbar-section-title {
  text-transform: uppercase;
}
.v-btn {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskToolbar.vue